import { NavLink } from 'react-router-dom';
import styled, { css, keyframes } from 'styled-components';

// Animation to sidebar when open/closes
const opacityAnimation = keyframes`
  0% { 
    display: none;
    opacity: 0;
  }
  100% {
    display: flex;
    opacity: 1;
  }
`;

interface SidebarProps {
  toggled?: boolean;
}

export const Container = styled.div<SidebarProps>`
  ${({ theme, toggled }) => css`
    position: absolute;
    top: 0;
    left: 0;

    height: 100%;
    max-width: 93px;
    width: 100%;
    background-color: ${theme.colors.backgroundBlue};
    flex: 1;
    padding: 32px;

    display: flex;
    flex-direction: column;
    align-items: center;

    transition: ${theme.transitions.default};

    ${DropdownItem}, ${Item} {
      > span {
        display: none;
        white-space: nowrap;

        animation: ${opacityAnimation} 1s ease-in-out;
      }
      > svg {
        margin-right: 0;
        font-size: 1.6rem;
      }
    }

    // Toggle animation when Sidebar is opened
    ${toggled
    && css`
      max-width: 249px;
      align-items: unset;

      ${DropdownItem}, ${Item} {
        > span {
          display: flex;
          opacity: 1;
        }

        > svg {
          margin-right: 14px;
        }
      }

      ${Brand} {
        width: 53px;
        height: 53px;
        border-radius: 17px;

        > img {
          max-width: 100%;
        }
      }

      ${ToggleButton} {
        > svg {
          transform: rotate(-180deg);
        }
      }

      ${LogoutButton} {
        > span {
          display: flex;
          opacity: 1;
        }

        > svg {
          margin-right: 14px;
        }
      }
    `};
  `};
`;

export const Brand = styled.div`
  ${({ theme }) => css`
    width: 35px;
    height: 35px;
    border-radius: 11px;
    background-color: transparent;
    margin-bottom: 54px;

    display: flex;
    align-items: center;
    justify-content: center;

    transition: ${theme.transitions.default};

    > img {
      width: 100%;
      transition: ${theme.transitions.default};
    }
  `};
`;

export const MenuItems = styled.ul``;

interface ItemProps {
  active?: boolean;
}

export const Item = styled(NavLink)<ItemProps>`
  ${({ theme }) => css`
    font-size: 1.2rem;
    line-height: 2.2rem;
    color: ${theme.colors.primary};
    font-weight: 600;
    opacity: 0.3;
    margin-bottom: 30px;
    cursor: pointer;

    display: flex;
    align-items: center;

    transition: ${theme.transitions.default};

    &:hover {
      opacity: 1;
    }

    &.active {
      opacity: 1;
    }
  `};
`;

export const ToggleButton = styled.button`
  ${({ theme }) => css`
    width: 27px;
    height: 27px;
    border-radius: 3px;
    background-color: #E8EBF1;
    color: ${theme.colors.primary};

    display: flex;
    align-items: center;
    justify-content: center;

    position: absolute;
    bottom: 53px;
    right: -17px;

    > svg {
      transition: ${theme.transitions.default};
    }
  `};
`;

export const DropdownItem = styled.div`
  ${({ theme }) => css`
    font-size: 1.2rem;
    line-height: 2.2rem;
    color: ${theme.colors.black};
    font-weight: 600;
    opacity: 0.3;
    margin-bottom: 30px;
    cursor: pointer;

    display: flex;
    align-items: center;

    transition: ${theme.transitions.default};

    &:hover {
      opacity: 1;
    }
  `};
`;

export const ToggleAction = styled.span`
  margin-left: auto;
`;

export const LogoutButton = styled.button`
  ${({ theme }) => css`
    color: #EA4335;
    font-size: 1.2rem;
    line-height: 2.2rem;
    font-weight: 600;
    margin-top: auto;
    background-color: transparent;
    
    display: flex;
    align-items: center;
    justify-content: flex-start;
    
    > span {
      display: none;
      white-space: nowrap;

      animation: ${opacityAnimation} 1s ease-in-out;
    }

    > svg {
      font-size: 1.8rem;
    }
  `};
`;
